class DeviceDetector {
  constructor() {
    this.breakpoint = 780;
    this.mediaQuery = window.matchMedia(`(min-width: ${this.breakpoint}px)`);
    this.isDesktop = this.mediaQuery.matches;
    this.isMobile = !this.isDesktop;
    this.isTouch = 'ontouchstart' in window;
    
    this.callbacks = {
      onDesktop: [],
      onMobile: []
    };
    
    this.init();
  }

  init() {
    this.addDeviceClasses();
    this.setupMediaQueryListener();
  }

  addDeviceClasses() {
    const html = document.documentElement;
    
    html.classList.remove('desktop', 'mobile', 'touch', 'no-touch');
    
    html.classList.add(
      this.isDesktop ? 'desktop' : 'mobile',
      this.isTouch ? 'touch' : 'no-touch'
    );
  }

  setupMediaQueryListener() {
    this.mediaQuery.addEventListener('change', (e) => {
      this.isDesktop = e.matches;
      this.isMobile = !e.matches;
      this.addDeviceClasses();
      
      if (e.matches) {
        this.callbacks.onDesktop.forEach(callback => callback());
      } else {
        this.callbacks.onMobile.forEach(callback => callback());
      }
    });
  }

  onDesktop(callback) {
    this.callbacks.onDesktop.push(callback);
    if (this.isDesktop) callback();
  }

  onMobile(callback) {
    this.callbacks.onMobile.push(callback);
    if (this.isMobile) callback();
  }

  static getInstance() {
    if (!DeviceDetector.instance) {
      DeviceDetector.instance = new DeviceDetector();
    }
    return DeviceDetector.instance;
  }
}

export default DeviceDetector; 